import React from "react";
import styles from "./DunkunInterview.module.css";
const DunkunInterview = (props) => {
  return (
    <>
      <div>
        <div className={styles.title}>
          Could you tell us a bit about MondayOFF? How did it all start?
        </div>
        <div className={styles.context}>
          Our co-founders and I wanted to develop our games and reach global
          audiences. At that time, most Korean mobile games were focusing on
          East Asia. So we believed that we could be one of the greatest gaming
          companies in the global market. In 2018, we founded our company,
          starting with a small office. That was the beginning of our story.
        </div>
      </div>
      <div>
        <div className={styles.title}>
          What was your motivation for creating a game studio and now publisher?
        </div>
        <div className={styles.context}>
          Hypercasual is not just a game. It must include psychological factors
          on its core mechanism to be successful. Those psychological factors
          should represent the common interest of huge audiences. It sounds like
          nothing special, but we face many failures during the development
          phase. However, this does not discourage us from moving on to the next
          project.
        </div>
      </div>
      <div>
        <div className={styles.title}>
          What are the biggest challenges in managing a Hyper casual studio?
        </div>
        <div className={styles.context}>
          The eCPM (Effective Cost Per Mille) is another metric often not spoken
          about, but it shows the revenue you have made per 1,000 impressions.
          Of course, knowing this can be super exciting but also disheartening.
          If your game is doing well, then the revenue will cover the Effective
          Cost Per Mille. This metric allows the developer to understand how
          much they will get paid per 1,000 impressions and for the publisher to
          know how much they should spend per 1,000 impressions. The goal is for
          the ROAS (Return on Ad Spend) to be more than 100%.{" "}
        </div>
      </div>
      <div>
        <div className={styles.title}>
          Before creating MondayOFF, did you have an interest in mobile games?
        </div>
        <div className={styles.context}>
          Yes. I love to play mobile games, and my old smartphone didn't have
          enough storage to download other games because I already had 100+
          games on it. That can explain how much I love mobile games. But after
          being the founder of MondayOFF, I couldn't play mobile games a lot. I
          should have played and enjoyed games, but now I usually judge and
          analyze game mechanisms.
        </div>
      </div>
      <div>
        <div className={styles.title}>
          What do you wish for MondayOFF in the future?
        </div>
        <div className={styles.lastContext}>
          I wish MondayOFF to be one of the Top #10 Hyper-casual publishers
          globally. That is what I want to achieve within two years from now. We
          have been doubling all of our data during the past couple of years. In
          2021, MondayOFF achieved 50 million downloads (25 million downloads
          during 2018 ~ 2020) with 10 million MAU (5 million MAU during 2020).
          The DAU and revenue are much more than our estimation. I hope you can
          wait for us and see our success in the future.
        </div>
        <div className={styles.lastContext}>
          I hope you enjoyed reading this brief interview and learned more about
          MondayOFF. Please visit our LinkedIn and follow us there to know more
          about us.
        </div>
      </div>
      <div className={styles.link}>
        <a
          href="https://www.linkedin.com/in/dunkun-kang-720233163/"
          target="_blank"
          rel="noreferrer"
        >
          Dunkun’s Linkedin
        </a>
        <a
          href="https://www.linkedin.com/company/mondayoff-inc"
          target="_blank"
          rel="noreferrer"
        >
          MondayOFF Linkedin
        </a>
      </div>
    </>
  );
};

export default DunkunInterview;
